<template>
  <div
    id="fake-tab"
    class="fake-tab"
    :class="{ 'fake-tab--disabled': disabled }"
  >
    <div
      class="fake-tab__title"
      :class="{ 'fake-tab__title--active': firstActive }"
      @click="handleClick()"
    >
      <span>{{ firstTitle }}</span>
      <md-tooltip v-if="firstTitleTooltip">
        {{ firstTitleTooltip }}
      </md-tooltip>
      <span
        v-if="firstCounter"
        class="fake-tab__counter"
        :class="{ 'fake-tab__counter--active': firstActive }"
      >
        {{ firstCounter }}
      </span>
    </div>
    <div
      class="fake-tab__title"
      :class="{ 'fake-tab__title--active': !firstActive }"
      @click="handleClick()"
    >
      <span>{{ secoundTitle }}</span>
      <md-tooltip v-if="firstTitleTooltip">
        {{ secoundTitleTooltip }}
      </md-tooltip>

      <span
        v-if="secoundCounter"
        class="fake-tab__counter"
        :class="{ 'fake-tab__counter--active': !firstActive }"
      >
        {{ secoundCounter }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FakeTab',
  props: {
    firstActive: {
      type: Boolean,
      default: false
    },
    firstTitle: {
      type: String,
      default: ''
    },
    firstTitleTooltip: {
      type: String,
      default: ''
    },
    firstCounter: {
      type: [Number, String],
      default: null
    },
    secoundTitle: {
      type: String,
      default: ''
    },
    secoundTitleTooltip: {
      type: String,
      default: ''
    },
    secoundCounter: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit('update', !this.firstActive)
      }
    }
  }
}
</script>

<style lang="scss">
.fake-tab {
  display: flex;
  margin-bottom: 25px;
  border-bottom: 1px solid #7f1a54;
  background-color: inherit;

  &--disabled {
    .fake-tab__title {
      cursor: progress;
    }
  }

  &__title {
    min-width: 155px;
    text-align: center;
    cursor: pointer;
    color: #979797;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 1.3px;
    text-transform: uppercase;
    padding: 12px 18px;
    position: relative;
    top: 1px;

    &--active {
      color: #7f1a54;
      border-top: 1px solid #7f1a54;
      border-left: 1px solid #7f1a54;
      border-right: 1px solid #7f1a54;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      background-color: #ebebeb;
      padding: 11px 17px 12px;
    }
  }
  &__counter {
    background-color: #c4c4c4;
    color: #fff;
    padding: 2px 9px;
    border-radius: 10px;
    margin-left: 3px;
    &--active {
      background-color: #7f1a54;
    }
  }
}
</style>
